import { useCallback } from 'react'

import { useUnit } from 'effector-react'

import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { $activeChatDetails } from '@/models/chattingUI/chats/chats.ts'
import { openDialog } from '@/models/dialogs.ts'
import { classNames } from '@/utils/helpers'

import StarIcon from '../../../icons/star.svg'
import { IconButton } from '../../components/icon-button'

export const SaveToListAction = () => {
  const chat = useUnit($activeChatDetails)
  const handleOpenManageListsDialog = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.SAVE_TO_LIST,
    })
  }, [])

  if (!chat) return null

  const isAlreadyAddedToList = !!chat.withUser.listsStates?.length

  return (
    <IconButton
      icon={StarIcon}
      onClick={handleOpenManageListsDialog}
      tooltip="Lists"
      iconClassName={classNames(
        'h-3 w-3 sm:h-5 sm:w-5',
        isAlreadyAddedToList && 'fill-primary-500 text-primary-500',
      )}
    />
  )
}
